var ENDPOINTS = {
    creditAccounts: '/v2/credit/accounts',
    accountSummary: '/v2/credit/accounts/summary',
    profile: '/v1/credit/accounts/profile',
    refundEligibility: '/v1/credit/account/balance-refund/available',
    refundExecution: '/v1/credit/account/balance-refund/request-refund',
    logout: '/v3/oauth2/logout'
};
export default ENDPOINTS;
